import {ApolloLink, Observable} from '@apollo/client';
import {getOperationType} from 'src/internal/shared/utils/gql';

import type {InternalOperation} from 'src/internal/apollo/types';

export default function createInteroperabilityLink(): ApolloLink {
  return new ApolloLink(function interoperabilityLink(
    operation: InternalOperation,
    forward,
  ) {
    const {interoperabilityLayer} = operation.getContext();
    const isQuery = getOperationType(operation.query) === 'query';

    return new Observable(function interoperabilityObserver(observer) {
      const subscription = forward(operation).subscribe({
        next: function interoperabilityObserverNext(result) {
          if (isQuery && !result.errors && interoperabilityLayer) {
            interoperabilityLayer.refreshQueryStaleness(
              operation.query,
              operation.variables,
            );
          }

          return observer.next(result);
        },

        error: function interoperabilityObserverError(error) {
          return observer.error(error);
        },

        complete: function interoperabilityObserverComplete() {
          return observer.complete();
        },
      });

      return function interoperabilityObserverUnsubscribe(): void {
        if (subscription) {
          subscription.unsubscribe();
        }
      };
    });
  });
}
